import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=4285693c&scoped=true"
import script from "./Publicity.vue?vue&type=script&lang=js"
export * from "./Publicity.vue?vue&type=script&lang=js"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=4285693c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285693c",
  null
  
)

export default component.exports